import React from "react";
import BaseSlider, {
  SliderProps as MuiSliderProps,
} from "@mui/material/Slider";
import { twMerge } from "tailwind-merge";

export type SliderProps = MuiSliderProps & {
  minLabel: string;
  maxLabel: string;
  className?: string;
} & (
    | {
        value: number;
        onChange: (value: number) => void;
      }
    | {
        value?: undefined;
        onChange?: undefined;
      }
  );

export const Slider: React.FC<SliderProps> = ({
  marks,
  min,
  max,
  step,
  minLabel,
  maxLabel,
  className,
  value,
  onChange,
}) => {
  return (
    <div className={twMerge("flex flex-col items-center w-full", className)}>
      <div className="w-[calc(100%-8px)]">
        <BaseSlider
          min={min}
          max={max}
          value={value}
          onChange={(_, value) => {
            if (onChange) {
              onChange(value as number);
            }
          }}
          step={step}
          marks={marks}
          slotProps={{
            thumb: {
              className:
                "!bg-primary flex items-center justify-center bg-red-400 rounded-full shadow absolute",
            },
            track: {
              className: "!bg-primary !border-primary",
            },
            mark: {
              className: "!bg-gray-500",
            },
            rail: {
              className: "!bg-gray-500",
            },
            markLabel: {
              className: "!text-gray-500",
            },
          }}
        />
      </div>
      <div className="flex flex-row justify-between w-full text-xs text-gray-700">
        <span>{minLabel}</span>
        <span>{maxLabel}</span>
      </div>
    </div>
  );
};
